module.exports = __webpack_public_path__ + "static/media/1005326.756dee67.png";